import React from 'react';
import placeholderImage from '../assets/placeholder.jpg';

function UserCard({ userData }) {
  // 格式化教育水平
  const formatEducation = (level) => {
    const educationMap = {
      1: '初中及以下',
      2: '高中',
      3: '大专/普通大学',
      4: '名牌大学/硕博'
    };
    return educationMap[level] || '未知';
  };

  // 格式化饮酒/抽烟习惯
  const formatHabit = (value) => {
    if (value === 0) return '从不';
    if (value === 1) return '偶尔';
    if (value === 2) return '习惯';
    return '未知';
  };

  // 格式化外貌
  const formatAppearance = (value) => {
    if (value === 1) return '一般';
    if (value === 2) return '好看';
    if (value === 3) return '非常好看';
    return '未知';
  };

  // 格式化性格
  const formatPersonality = (value) => {
    if (value === 'i') return '内向';
    if (value === 'e') return '外向';
    return '未知';
  };

  return (
    <div className="user-card">
      <div className="card-image-container">
        <img src={placeholderImage} alt="用户照片" className="card-image" />
      </div>
      <div className="card-content">
        <h2 className="card-name">
          {userData.self_screen_name || '匿名用户'}, {userData.self_age}岁
        </h2>
        <div className="card-details">
          <div className="detail-item">
            <span className="detail-label">职业:</span>
            <span className="detail-value">{userData.self_job || '未填写'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">身高:</span>
            <span className="detail-value">{userData.self_height} cm</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">外貌:</span>
            <span className="detail-value">{formatAppearance(userData.self_appearance)}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">学历:</span>
            <span className="detail-value">{formatEducation(userData.self_education)}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">年收入:</span>
            <span className="detail-value">{userData.self_annual_income} 万</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">房产:</span>
            <span className="detail-value">{userData.self_property === 1 ? '有房' : '无房'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">抽烟:</span>
            <span className="detail-value">{formatHabit(userData.self_smoking)}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">饮酒:</span>
            <span className="detail-value">{formatHabit(userData.self_drinking)}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">性格:</span>
            <span className="detail-value">{formatPersonality(userData.self_personality)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserCard;